import { round } from 'app/utils/number';

// Sort properties in this array by wanted display order
const AVAILABLE_PROPERTIES: Partial<
  Record<
    VideogameSlug,
    { name: string; compactVersion: boolean; order: 'ascending' | 'descending' }[]
  >
> = {
  'cs-go': [
    { name: 'kd', compactVersion: true, order: 'descending' },
    { name: 'k', compactVersion: false, order: 'descending' },
    { name: 'd', compactVersion: false, order: 'ascending' },
    { name: 'adr', compactVersion: true, order: 'descending' },
    { name: 'kast', compactVersion: true, order: 'descending' }
  ]
};

// Sort properties in this array by wanted display order
const getCsPlayersStats = (player: StatPlayerCs): (number | null)[] => [
  player.kills_per_game && player.deaths_per_game
    ? round(player.kills_per_game / player.deaths_per_game, 2)
    : null,
  player.kills_per_game ?? null,
  player.deaths_per_game ?? null,
  player.average_damage_per_round ? round(player.average_damage_per_round, 2) : null,
  player.kast ? round(player.kast, 1) : null
];

const getPlayerStat = (
  player: StatPlayer & { opponent: OpponentBase | undefined },
  videogame: VideogameSlug
): PlayerBase & { stats: (number | null)[]; opponent: OpponentBase | undefined } => {
  let stats: (number | null)[] = [];
  switch (videogame) {
    case 'cs-go':
      stats = getCsPlayersStats(player as StatPlayerCs);
      break;
    default:
      stats = [];
  }
  return {
    id: player.id,
    name: player.name,
    opponent: player.opponent,
    stats
  };
};

export { AVAILABLE_PROPERTIES, getPlayerStat };
